import store from '@/state/store';
import { confirmByEmail } from '@/api/auth';
import registrationSlice from '@/state/registration.slice';
import authenticationSlice from '@/state/authentication.slice';
import { VerificationErrorCodes } from '@bimdata/definitions/errors';
import { initSession } from '@/loaders/profile';
import { handleError, reportError } from '../common';
import t from '@/utils/translate';

export default async (code: string) => {
  const state = store.getState();

  try {
    await confirmByEmail({
      code,
      ...(state.registration.claimId ? { claim: state.registration.claimId } : {})
    });
    store.dispatch(registrationSlice.actions.confirmed());
    if (state.registration.claimId) {
      store.dispatch(authenticationSlice.actions.finishEmailVerification());
      store.dispatch(authenticationSlice.actions.finishLogin());
      await initSession();
    }
  } catch (error) {
    store.dispatch(registrationSlice.actions.rejectRegistration());

    if (error.code === 403) {
      let message;
      switch (error.exceptionCode) {
        case VerificationErrorCodes.VERIFICATION_EXPIRED:
          message = t('authentication.message.staleEmailLink');
          break;
        case VerificationErrorCodes.INVALID_VERIFICATION_CODE:
          message = t('authentication.message.invalidEmailLink');
          break;
        case VerificationErrorCodes.ALREADY_VERIFIED:
          store.dispatch(authenticationSlice.actions.finishEmailVerification());
          return;
      }
      reportError(error, message);
    } else {
      handleError(error);
    }

    throw error;
  }
};

